export type TimeSlot = {
  from: string;
  to: string;
  selected: boolean;
};

export type ArrivalWindowType = {
  slot: string;
  selected: boolean;
  disabled: boolean;
  isoFrom: string;
  isoTo: string;
  from: number;
  to: number;
};

export type Appointment = Omit<TimeSlot, 'selected'> & {
  availableAppointmentId: string;
  timezone: string;
};

export enum DaysOfWeek {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}

export enum CarouselDirection {
  PREVIOUS,
  NEXT,
}

export const UNSCHEDULED = 'UNSCHEDULED';
export const GET_WORK_ORDER_RETRY_COUNT = 3;
